/**
 * 兑换码
 * 兑换码API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import IdNameVo from './IdNameVo';




  /**
   * The RedeemCodeBatchVo model module.
   * @module redeem_code/model/RedeemCodeBatchVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>RedeemCodeBatchVo</code>.
   * @alias module:redeem_code/model/RedeemCodeBatchVo
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>RedeemCodeBatchVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:redeem_code/model/RedeemCodeBatchVo} obj Optional instance to populate.
   * @return {module:redeem_code/model/RedeemCodeBatchVo} The populated <code>RedeemCodeBatchVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'textbook')) {
        obj['textbook'] = IdNameVo.constructFromObject(data['textbook']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'codeNum')) {
        obj['codeNum'] = ApiClient.convertToType(data['codeNum'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 教材
   * @member {module:redeem_code/model/IdNameVo} textbook
   */
  exports.prototype['textbook'] = undefined;
  /**
   * 兑换码的数量
   * @member {Integer} codeNum
   */
  exports.prototype['codeNum'] = undefined;
  /**
   * 备注
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;



  export default exports;
;


